// src/data/dropdownOptions.ts

import { DropdownOptions, DSPSubgenreMap } from "../types/dropdownTypes";

export const dspDropdownOptions: DropdownOptions = {
  configuration: ["Song", "Album", "EP", "Waterfall"],

  musicCulture: [
    "African",
    "Arabic",
    "Buddhist",
    "Caribbean",
    "Celtic",
    "Christian",
    "Hindu",
    "Indigenous",
    "Islamic",
    "Judaic",
    "Latin",
    "Sikh",
    "South African",
    "None Of These",
  ],

  instruments: [
    "Accordion",
    "Acoustic Guitar",
    "Banjo",
    "Bass Guitar",
    "Buzuq",
    "Cello",
    "Drum Kit",
    "Electric Guitar",
    "Erhu",
    "Fiddle",
    "Flute",
    "Harmonica",
    "Harp",
    "Kora",
    "Mandolin",
    "Mbira",
    "Oboe",
    "Organ",
    "Oud",
    "Pedal Street Guitar",
    "Piano",
    "Samples",
    "Sanxian",
    "Sarod",
    "Sitar",
    "Steel Drum",
    "Synthesizer",
    "Tabla",
    "Trombone",
    "Trumpet",
    "Ukelele",
    "Violin",
    "Xylophone",
  ],

  songStyle: [
    "Acoustic",
    "Ballad",
    "Beats",
    "Christmas",
    "Experimental",
    "Holiday",
    "Kids",
    "Traditional",
    "None of these",
  ],

  priority: [
    "High Priority",
    "Priority",
    "Genre Priority",
    "Low Genre Priority",
    "Standard Release",
  ],

  deezerEditorialTeam: [
    "GLOBAL",
    "FR",
    "BRA",
    "SP",
    "MX",
    "PT",
    "IT",
    "JP",
    "UK",
    "BENELUX",
    "DE",
    "CL",
  ],
  mainGenre: [
    "Acoustic",
    "Children's",
    "Classical",
    "Country",
    "Dance & Electronic",
    "Holiday",
    "Indian Music",
    "Indie & Alternative",
    "Jazz",
    "Latin Music",
    "New Age",
    "Non-Music",
    "Pop",
    "R&B",
    "Rap & Hip-Hop",
    "Religious Music",
    "Rock",
    "World",
  ],
  songCategory: [
    "Chilling Out & Lounging",
    "Happy & Upbeat",
    "Relaxed & Laid Back",
    "Work, Study, & Reading",
    "Hard & Heavy",
  ],
  songDescription: [
    "Live",
    "Studio",
    "Remix",
    "Cover",
    "Instrumental",
    "Reissue",
    "Alternate Version",
    "Instant Grat",
    "Pre-Save",
  ],
  songMood: [
    "Angry",
    "Chill",
    "Cool",
    "Dark",
    "Energetic",
    "Fast",
    "Fierce",
    "Happy",
    "Heavy",
    "Intense",
    "Light",
    "Meditative",
    "Mellow",
    "Motivational",
    "Relaxing",
    "Romantic",
    "Sad",
    "Sexy",
    "Soft",
    "Upbeat",
    "None Of These",

  ],
  language: [
    "Abkhazian",
    "Afar",
    "Afrikaans",
    "Akan",
    "Albanian",
    "Amharic",
    "Arabic",
    "Aragonese",
    "Armenian",
    "Assamese",
    "Avaric",
    "Avestan",
    "Aymara",
    "Azerbaijani",
    "Bambara",
    "Bashkir",
    "Basque",
    "Belarusian",
    "Bihari",
    "Bislama",
    "Bosnian",
    "Breton",
    "Bulgarian",
    "Burmese",
    "Catalan",
    "Chamorro",
    "Chechen",
    "Chinese",
    "Church Slavic",
    "Chuvash",
    "Cornish",
    "Corsican",
    "Cree",
    "Croatian",
    "Czech",
    "Danish",
    "Divehi",
    "Dutch",
    "Dzongkha",
    "English",
    "Esperanto",
    "Estonian",
    "Ewe",
    "Faroese",
    "Fijian",
    "Finnish",
    "French",
    "Fulah",
    "Galician",
    "Ganda",
    "Georgian",
    "German",
    "Greek",
    "Guarani",
    "Gujarati",
    "Haitian Creole",
    "Hausa",
    "Hebrew",
    "Herero",
    "Hindi",
    "Hiri Motu",
    "Hungarian",
    "Icelandic",
    "Ido",
    "Igbo",
    "Indonesian",
    "Interlingua",
    "Inuktitut",
    "Inupiaq",
    "Irish",
    "Italian",
    "Japanese",
    "Javanese",
    "Kalaallisut",
    "Kannada",
    "Kanuri",
    "Kashmiri",
    "Kazakh",
    "Khmer",
    "Kikuyu",
    "Kinyarwanda",
    "Komi",
    "Kongo",
    "Korean",
    "Kuanyama",
    "Kurdish",
    "Kyrgyz",
    "Lao",
    "Latin",
    "Latvian",
    "Limburgish",
    "Lingala",
    "Lithuanian",
    "Luba-Katanga",
    "Luxembourgish",
    "Macedonian",
    "Malagasy",
    "Malay",
    "Malayalam",
    "Maltese",
    "Manx",
    "Maori",
    "Marathi",
    "Marshallese",
    "Moldavian",
    "Mongolian",
    "Nauru",
    "Navajo",
    "Ndonga",
    "Nepali",
    "North Ndebele",
    "Northern Sami",
    "Norwegian",
    "Norwegian Bokmål",
    "Norwegian Nynorsk",
    "Nyanja",
    "Occitan",
    "Odia",
    "Ojibwa",
    "Oromo",
    "Ossetic",
    "Pali",
    "Pashto",
    "Persian",
    "Polish",
    "Portuguese",
    "Punjabi",
    "Quechua",
    "Romanian",
    "Romansh",
    "Rundi",
    "Russian",
    "Samoan",
    "Sango",
    "Sanskrit",
    "Sardinian",
    "Scottish Gaelic",
    "Serbian",
    "Shona",
    "Sichuan Yi",
    "Sindhi",
    "Slovak",
    "Slovenian",
    "Somali",
    "South Ndebele",
    "Southern Sotho",
    "Spanish",
    "Sudanese",
    "Swahili",
    "Swati",
    "Swedish",
    "Tagalog",
    "Tahitian",
    "Tajik",
    "Tamil",
    "Tatar",
    "Telugu",
    "Thai",
    "Tibetan",
    "Tigrinya",
    "Tongan",
    "Tsonga",
    "Tswana",
    "Turkish",
    "Turkmen",
    "Twi",
    "Ukrainian",
    "Urdu",
    "Uyghur",
    "Uzbek",
    "Venda",
    "Vietnamese",
    "Volapük",
    "Walloon",
    "Welsh",
    "Western Frisian",
    "Wolof",
    "Xhosa",
    "Yiddish",
    "Yoruba",
    "Zhuang",
    "Zulu",
  ],
  listenersLocation: [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua & Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bosnia & Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "British Indian Ocean Territory",
    "British Virgin Islands",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Caribbean Netherlands",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands",
    "Colombia",
    "Comoros",
    "Congo - Brazzaville",
    "Congo - Kinshasa",
    "Cook Islands",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Curaçao",
    "Cyprus",
    "Czechia",
    "Côte D'Ivoire",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Falkland Islands",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard & McDonald Islands",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle Of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar (Burma)",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "North Korea",
    "North Macedonia",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestinian Territories",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn Islands",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Romania",
    "Rwanda",
    "Réunion",
    "Samoa",
    "San Marino",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia & South Sandwich Islands",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "St. Barthélemy",
    "St. Helena",
    "St. Kitts & Nevis",
    "St. Lucia",
    "St. Martin",
    "St. Pierre & Miquelon",
    "St. Vincent & Grenadines",
    "Sudan",
    "Suriname",
    "Svalbard & Jan Mayen",
    "Sweden",
    "Switzerland",
    "Syria",
    "São Tomé & Príncipe",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad & Tobago",
    "Tunisia",
    "Turkmenistan",
    "Turks & Caicos Islands",
    "Tuvalu",
    "Türkiye",
    "U.S. Outlying Islands",
    "U.S. Virgin Islands",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Wallis & Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe",
    "Åland Islands",
  ],

  artistCountry: [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua & Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bosnia & Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "British Indian Ocean Territory",
    "British Virgin Islands",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Caribbean Netherlands",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands",
    "Colombia",
    "Comoros",
    "Congo - Brazzaville",
    "Congo - Kinshasa",
    "Cook Islands",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Curaçao",
    "Cyprus",
    "Czechia",
    "Côte D'Ivoire",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Falkland Islands",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard & McDonald Islands",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle Of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar (Burma)",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "North Korea",
    "North Macedonia",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestinian Territories",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn Islands",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Romania",
    "Rwanda",
    "Réunion",
    "Samoa",
    "San Marino",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia & South Sandwich Islands",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "St. Barthélemy",
    "St. Helena",
    "St. Kitts & Nevis",
    "St. Lucia",
    "St. Martin",
    "St. Pierre & Miquelon",
    "St. Vincent & Grenadines",
    "Sudan",
    "Suriname",
    "Svalbard & Jan Mayen",
    "Sweden",
    "Switzerland",
    "Syria",
    "São Tomé & Príncipe",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad & Tobago",
    "Tunisia",
    "Turkmenistan",
    "Turks & Caicos Islands",
    "Tuvalu",
    "Türkiye",
    "U.S. Outlying Islands",
    "U.S. Virgin Islands",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Wallis & Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe",
    "Åland Islands",
  ],

  LabelDistributor: [
    "_Indie",
    "!K7",
    "!K7 GSA",
    "3Tone",
    "3Tone GSA",
    "4AD",
    "12Tone",
    "13_31",
    "88 Rising",
    "300 Entertainment",
    "ABKCO",
    "Above Board",
    "ADA",
    "ADA Brazil",
    "ADA France",
    "ADA Iberia",
    "ADA Italy",
    "Africori",
    "Agora",
    "Alamo Records",
    "ALOADED AB",
    "Altafonte Latin",
    "Altafonte Brazil",
    "Altafonte Italy",
    "Altafonte Portugal",
    "Altafonte Spain",
    "Alter-K",
    "Amuseio AB",
    "Analekta",
    "Anthem Records",
    "ANTI-",
    "ANXT",
    "Ao Sul do Mundo",
    "Overtone Studios",
    "Aparté",
    "Apollo",
    "Apron Records",
    "Aquarius Records",
    "Arising Empire",
    "Arista",
    "Armada",
    "Arruada",
    "Artist First",
    "Artist Partner Group (APG)",
    "Arts Music",
    "ASCAP",
    "Asfalt",
    "Astralwerks / Capitol",
    "Asylum",
    "Atlantic Records",
    "Atlantic UK",
    "AudioSalad",
    "AudioSalad Norway",
    "Aus Music",
    "AVIE Records",
    "AWAL",
    "AWAL UK",
    "Azáfama",
    "Azuri",
    "Baco Records",
    "Balkaton",
    "Banzé",
    "Basic & Rough",
    "Bassivity Digital",
    "Because Music",
    "Because Portugal",
    "Beggars Group",
    "Beggars Group France",
    "Beggars Group UK",
    "Believe",
    "Believe (Classical)",
    "Believe (Latin)",
    "Believe Africa",
    "Believe Balkans",
    "Believe Brazil",
    "Believe Europe (Metal)",
    "Believe France",
    "Believe GSA",
    "Believe Italy",
    "Believe MENA",
    "Believe Nordics",
    "Believe Poland",
    "Believe Portugal",
    "Believe Singapore",
    "Believe Spain",
    "Beton Music",
    "Better Noise Music",
    "Big Beat",
    "Big Bit",
    "Big Loud Records",
    "Big Machine Label Group",
    "Bigo and Twigetti",
    "Biscoito Fino",
    "Blac Noize!",
    "Blackground",
    "BMG",
    "BMG Brazil",
    "BMG France",
    "BMG Italy",
    "BMG Spain",
    "BMI",
    "brandit",
    "BRM",
    "Broken Bow Records",
    "Cantaloupe",
    "Cantus",
    "Canvasback",
    "Capitol - Electronic & Dance",
    "Capitol CMG",
    "Capitol Records",
    "Cargo Digital France",
    "Cargo Digital GSA",
    "Cargo Records UK",
    "Cass Ching",
    "CD Baby",
    "CD Baby (Latin)",
    "Cedille",
    "Celinka",
    "Century Media",
    "Challenge Classics",
    "Cinematic Worldwide",
    "Cing Music",
    "City Slang",
    "CmdShft",
    "Columbia Records",
    "Communion Records",
    "Compass Records",
    "Concord Recorded Music",
    "Content Connect Africa",
    "Cosmic Burger",
    "Cousin",
    "Create Music Group",
    "Crni Cerak",
    "Croatia Records",
    "Crush",
    "Cruz Del Sur Music",
    "Cupula",
    "Dallas Records Croatia",
    "Dallas Records Slovenia",
    "Danal Entertainment",
    "Dancing Bear",
    "Danmark Music Group",
    "Dawn",
    "Dead Oceans",
    "Decca Records",
    "Deckdisk",
    "Def Jam",
    "Dekmantel",
    "Deutsche Grammophon",
    "DFSB Kollective",
    "Diepgraven Records",
    "Disco:Wax",
    "Diskover",
    "Disney Music",
    "DistroKid",
    "DistroKid Norway",
    "Ditto",
    "Ditto Africa",
    "Ditto Brazil",
    "Ditto France",
    "Ditto GSA",
    "Ditto Spain",
    "Divizzion",
    "Domino",
    "Dostava zvuka",
    "Downtown Music",
    "DTX",
    "Dvpper",
    "East West",
    "ECM",
    "Ejoya",
    "Elektra Records",
    "emPawa Africa",
    "EMPIRE",
    "Empire Africa",
    "Empire Latino",
    "Empire Portugal",
    "Empire WANA",
    "eMuzyka",
    "Encore Recordings",
    "Epic Records",
    "Epidemic Sound",
    "Epitaph Records",
    "EPM",
    "Equity/EQ",
    "Everlasting",
    "Fabien",
    "Family Ties Entertainment",
    "Farolatino",
    "Fat Possum",
    "Fayo Music",
    "FFRR",
    "Fluxus",
    "Força de Produção",
    "ForMusic",
    "Foundation Media",
    "Frontiers Records s.r.l.",
    "FUGA",
    "FUGA (K-Pop)",
    "FUGA Africa",
    "FUGA Brazil",
    "FUGA GSA",
    "FUGA Italy",
    "FUGA Portugal",
    "FUGA Spain",
    "FUGA UK",
    "Future Classic",
    "Fysisk Format",
    "Gaither Music Group",
    "Geffen Records",
    "Generacija Zed",
    "Genie Music",
    "Ghostly International",
    "Glassnote Entertainment Group LLC",
    "Glitch Records",
    "Good Output",
    "Graduation",
    "Gudu Records",
    "Hammerheart Records",
    "Harmonia Mundi",
    "Heir Wave Music Group",
    "HIT Records",
    "HITCO",
    "Hopeless Records",
    "Horus Music",
    "HYBE",
    "Hyperdub",
    "IDJDigital",
    "IDJTunes",
    "IDM Music",
    "IDOL France",
    "IDOL GSA",
    "iGroove",
    "iMusics",
    "In House Press",
    "INAXXS",
    "Independent Co. (Jessie)",
    "Independent Digital",
    "Indie Recordings",
    "Industre Works (Latin)",
    "Infamous PR",
    "InGrooves",
    "InGrooves (Latin)",
    "InGrooves Brazil",
    "InGrooves Denmark",
    "InGrooves GSA",
    "InGrooves Italy",
    "InGrooves Nordic",
    "InGrooves Spain",
    "Integral",
    "Integral (Classical)",
    "Integral France",
    "Integral UK",
    "Interscope (Latin)",
    "Interscope Records",
    "Ionekorea",
    "Island Records",
    "Kapa Records",
    "Karpo Media",
    "Kayax",
    "Kompakt",
    "Kondzilla",
    "Kontor New Media",
    "Kontra",
    "Kranky",
    "KT",
    "Kuroneko",
    "La Dolce Vita",
    "LAA",
    "Label Worx",
    "Label-Engine",
    "Lampshade Media",
    "Legacy Recordings",
    "Leitura Tropical",
    "Level",
    "Level: UP",
    "Local Action",
    "Locomotiva Azul",
    "Loma Vista Recordings",
    "Long Branch Records",
    "Long Play",
    "Lovers & Lollypops",
    "Lujo",
    "Mad Decent/Higher Ground",
    "Mad Solutions",
    "Made in BLKN",
    "Matador",
    "Match Attack",
    "Mau5trap",
    "MEDIAsounds",
    "Melides Art Records",
    "MENART Croatia",
    "MENART Serbia",
    "MENART Slovenia",
    "Mercury Records",
    "Merge",
    "Metal Blade Records",
    "MGM",
    "Midas Music",
    "Mighty Music",
    "MK",
    "MNRK (fka eOne)",
    "Modern Matters",
    "Modulor",
    "Mom + Pop",
    "Monarch",
    "Monument",
    "Moonbug",
    "Moonlee Records",
    "Motown Records",
    "Museu do Fado",
    "Music Adders",
    "Music As Usual",
    "MyMusic",
    "Mystic",
    "Nacional Records",
    "naïve",
    "Napalm Records",
    "Naxos",
    "Nettwerk Records",
    "New Amsterdam",
    "New Focus Recordings",
    "New West",
    "Nice Life",
    "Nick Music",
    "NIKA Records",
    "Ninja Tune",
    "Nonesuch",
    "Nuclear Blast",
    "ONErpm",
    "ONErpm (Latin)",
    "ONErpm Africa",
    "ONErpm Brazil",
    "ONErpm Spain",
    "Outhere",
    "OVO Sound",
    "Panela Rec",
    "Parabellum Official",
    "Paraty",
    "PENTATONE",
    "Photofinish Records",
    "PIAS",
    "PIAS France",
    "PIAS GSA",
    "PIAS Poland & Eastern Europe",
    "PIAS Spain",
    "Planet Mu",
    "Platoon",
    "Platoon Africa",
    "Play Two",
    "Playground Music Denmark",
    "Playground Music Norway",
    "PLZ Make It Ruins",
    "Polydor Records",
    "Polymoon",
    "Primeira Linha",
    "Prisma Music",
    "Prospero Classical",
    "Prosthetic Records",
    "Provident",
    "Quadio",
    "Range",
    "RCA - Hip-Hop and R&B",
    "RCA - Pop, Alternative & Dance",
    "RCA Inspiration",
    "recordjet",
    "Red Bull Records",
    "Red Star Productions",
    "Redeye France",
    "Redeye GSA",
    "Redeye Worldwide",
    "Repost / Soundcloud",
    "Repost / Soundcloud (Latin)",
    "Republic Records",
    "Republic of Music",
    "Republic Records (Latin)",
    "Reservoir",
    "Revolve",
    "Rhino Records",
    "Rimas",
    "Roadrunner Records",
    "Roc Nation",
    "Rotten Records",
    "Rough Trade Records",
    "Routenote",
    "Rubicon",
    "Saban Music Group",
    "Saddle Creek",
    "SBM",
    "SBS Music",
    "Scardona",
    "Season of Mist",
    "Secret City",
    "Secretly Distribution",
    "Seed",
    "SHARPTONE",
    "Signum Records",
    "Sipa Music",
    "Smithsonian Folkways",
    "Soave",
    "Solid State Records",
    "Som Livre",
    "Sony Classical",
    "Sony Masterworks",
    "Sony Music Africa",
    "Sony Music AU",
    "Sony Music Brazil",
    "Sony Music Canada",
    "Sony Music Denmark",
    "Sony Music France",
    "Sony Music GSA",
    "Sony Music Hong Kong",
    "Sony Music Italy",
    "Sony Music Korea",
    "Sony Music Latin",
    "Sony Music Legacy",
    "Sony Music México",
    "Sony Music Middle East",
    "Sony Music Nashville",
    "Sony Music Norway",
    "Sony Music Poland",
    "Sony Music Portugal",
    "Sony Music Singapore",
    "Sony Music Spain",
    "Sony Music UK",
    "Sound On",
    "Sparta",
    "Spectrum",
    "Spinefarm",
    "Spinefarm Records UK",
    "Spona",
    "Stem",
    "Stereofox",
    "Street Mission Records",
    "Sua Música",
    "SunPop",
    "Supa Squad",
    "Symphonic",
    "Symphonic Brazil",
    "Symphonic Latino",
    "System Records",
    "Tailored Communication",
    "TDKM",
    "Technicolour",
    "The Orchard",
    "The Orchard (Classical)",
    "The Orchard (Latin)",
    "The Orchard (Metal)",
    "The Orchard Balkans",
    "The Orchard Brazil",
    "The Orchard Denmark",
    "The Orchard France",
    "The Orchard GSA",
    "The Orchard Italy",
    "The Orchard Norway",
    "The Orchard Poland",
    "The Orchard Portugal",
    "The Orchard Spain",
    "Third Man",
    "Thirty Tigers",
    "Toby",
    "Tonika",
    "Toolroom Records",
    "Translation Loss Records",
    "Tratore",
    "Triple Threat",
    "TuneCore",
    "Uguru",
    "Ultra Records",
    "UMC",
    "UMe",
    "UMG Nashville",
    "UMLE",
    "Unique Leader Records",
    "UnitedMasters",
    "UnitedMasters Brazil",
    "Universal Music Africa Abidjan",
    "Universal Music Brazil",
    "Universal Music Denmark",
    "Universal Music France",
    "Universal Music GSA",
    "Universal Music Hong Kong",
    "Universal Music Italy",
    "Universal Music Korea",
    "Universal Music Norway",
    "Universal Music Poland",
    "Universal Music Portual",
    "Universal Music Singapore",
    "Universal Music South Africa",
    "Universal Music UK",
    "Universal Music Western Balkans",
    "Valentim de Carvalho",
    "Venice",
    "Verve",
    "Virgin Music",
    "Virgin Music - Electronic",
    "Virgin Music - Latin",
    "Virgin Music Balkans",
    "Virgin Music Portugal",
    "Virginia Records",
    "vise manje zauvijek",
    "Vydia",
    "Vydia Brazil",
    "Wagram France",
    "Wagram GSA",
    "Warner Classics",
    "Warner Music Australia",
    "Warner Music Brazil",
    "Warner Music Denmark",
    "Warner Music Finland",
    "Warner Music Germany",
    "Warner Music Hong Kong",
    "Warner Music Italy",
    "Warner Music Japan",
    "Warner Music Korea",
    "Warner Music Latina/Warner Latin",
    "Warner Music Middle East",
    "Warner Music Nashville/Elektra",
    "Warner Music Norway",
    "Warner Music Poland",
    "Warner Music Portugal",
    "Warner Music SEE",
    "Warner Music Singapore",
    "Warner Music South Africa",
    "Warner Music Spain",
    "Warner Music Sweden",
    "Warner Nashville",
    "Warner Records",
    "Warner Records UK",
    "Warp Records",
    "Wax Bodega",
    "Wiseband France",
    "Wiseband GSA",
    "Worldeater Records",
    "XL",
    "Year of the Rat Records",
    "Yem",
    "YG Entertainment & YG PLUS",
    "Young",
    "Zebralution Brazil",
    "Zebralution GSA",
    "Zebralution Portugal",
    "Zicer Inc.",
    "Ziiki Media",
    "Universal Music Group Classics",
    "5020 Records",
    "Symphonic Africa",
    "10K Projects",
    "Too Lost",
    "Distrokid GSA",
    "iMusician GSA",
    "Thrill Jockey",
    "Rich Music",
    "Torrez Music Group",
    "Nettwerk EU",
    "Pop Depression",
    "Krokodil Studio",
    "Xelon Digital",
    "Roster (SoundCloud)",
    "Intek Music",
    "93 SIGMA",
    "DashGo",
    "BMG UK",
    "The Orchard UK",
    "PIAS UK",
    "Ditto UK",
    "Absolute",
    "Island Records UK",
    "EMI (UK)",
    "Virgin Music UK",
    "Polydor Records UK",
    "Pulse Music Group",
    "0207 Def Jam",
    "Believe UK",
    "IDOL UK",
    "Fearless Records",
    "Artist Publishing Group (APG)",
    "Sony Music Entertainment (SME)",
    "Universal Music Group (UMG)",
    "Warner Music Group (WMG)",
    "Motown Gospel",
    "Re:Think",
    "Rise Records",
    "RBC Records",
    "MUGO",
    "ID Records",
    "London Records",
    "Because London Records",
    "Partisan",
    "Tonal Union",
    "SANTA ANNA",
    "Fundacja Muzyki Niezaleznej",
    "JuNouMi Records",
    "Peleton Records",
    "Seszele Records",
    "Soulspazm",
    "Universal Music Canada",
    "Mascot Records",
    "Alpha Classics",
    "Arcana",
    "B Records",
    "Bru Zane",
    "Channel Classics",
    "Château de Versailles Spectacles",
    "Eloquentia",
    "Cinquillo",
    "EnPhases",
    "Fuga Libera",
    "ICA Classics",
    "La Dolce Volta",
    "Linn Records",
    "MarchVivo",
    "Musique en Wallonie",
    "Muso",
    "Outnote Records",
    "Paradizo",
    "Phi",
    "Ramée",
    "Ricercar",
    "Roldán",
    "Shiiin",
    "Incises",
    "Getty Music (GTM)",
    "Dream",
    "Tamla Records",
    "First Word Records",
    "Kudos Records",
    "EGA Distro",
    "Fat Cat / 130701",
    "Audax Records",
    "Berliner Philharmoniker Recordings",
    "Chandos",
    "Colin Currie Records",
    "Evidence Classics",
    "King's College Cambridge",
    "LSO Live",
    "NoMadMusic",
    "The Cleveland Orchestra",
    "Télès Music",
    "Conscious Music Group",
    "Kartel Music Group",
    "Altafonte Music Distribution",
    "Evolution Ltd.",
    "HARD COPY Records",
    "SLCKR",
    "Sing Hosanna",
    "evokids",
    "evoXS",
    "evosound",
    "River Of Joy",
    "Disk Eyes",
    "Just Poppin",
    "Curb Records",
    "Daredo",
    "Noble Demon",
    "Zebralution US",
    "Zebralution UK",
    "We're Trying Records",
    "digdis!",
    "Palm Tree Records",
    "Blue Note Records",
    "Memphis Industries",
    "GYROstream",
    "Anjunabeats",
    "Vertigo / Capitol",
    "Chapter ONE Records",
    "Airforce1",
    "Electrola",
    "Urban Records",
    "Virgin Records Germany",
    "Polydor / Island (Germany)",
    "RCA Records",
    "Rebeat",
    "Bungalo",
    "GroundUP Music LLC",
    "SoundOn",
    "Jonas Entertainment Group",
    "Connect Music",
    "Sounds Australia",
    "International Anthem",
    "Delos",
    "ReLo-Co Music",
    "Cigol Music",
    "Hecho A Mano Music",
    "Mr. 305 Records",
    "Muve Recordings",
    "IDOL",
    "SideHustle",
    "Hidden Beach",
    "Warner Chappell Music (WCM)",
    "MOODWAVE",
    "Reach Records",
    "Chrysalis Records",
    "Puntilla",
    "Cygnus Music",
    "Ironshore Records USA",
    "BloodBlast",
    "Warner Music Canada",
    "Snapper Music",
    "Kscope Music",
    "Peaceville Records",
    "COLORSxSTUDIOS",
    "NMC Recordings",
    "Revelator",
  ],
  options: [
    "Mapping Request",
    "Release Priority",
    "Canonization",
    "Track Migration",
    "Misingested Content",
    "Missing Tracks",
    "Artwork Change",
    "Paywall Tier Moves",
    "Pro Unlimited Upgrade",
    "Profile Verification",
  ],

  soundCloudContact: [
    "Cameron Cox",
    "Caroline Adley",
    "Chris Johnson",
    "Denys Wilcox",
    "Drea Jackson",
    "Fatima Medrano",
    "Jack Bridges",
    "Jalen Parrish",
    "Matt Smith",
    "Roberto Bua",
    "Tricia Tranquillo",
    "Indie Label Submission",
    "Merlin Member Submission",
  ],
  promotionTerritories: [
    "US",
    "CA",
    "GB",
    "DE",
    "FR",
    "AU",
    "NZ",
    "NL",
    "IE",
    "IT",
    "ES",
    "CH",
    "BE",
    "PT",
    "SE",
    "NO",
    "DK",
    "FI",
  ],

  freshMusicFriday: [
    "Fresh Music Friday (US)",
    "Fresh Music Friday (CA)",
    "Fresh Music Friday (UK)",
    "Fresh Music Friday (AU)",
    "Fresh Music Friday (DE)",
    "Fresh Music Friday (FR)",
  ],

  playlistConsideration: [
    "¡ARRIBA!: Nueva Música Mexicana",
    "ACCELERATE: Future-Pop",
    "AFRO BOPS: New Afrobeats",
    "BACKROADS: Best Country Now",
    "BARS: Best UK Rap",
    "BASSBIN: Fresh Drums & Bass",
    "BELTERS: UK & Ireland Dance",
    "BOOMIN': Feel-Good Hip-Hop",
    "BOOTSTRAPS: New Country Rap",
    "BORDERLESS: Global Beats Now",
    "CHRISTMAS CLASSICS (SEASONAL)",
    "CLOSER: Emerging R&B",
    "CLUB HEAT: New Dance Now",
    "DIALED IN: Pop Hits",
    "DREAMS: Emerging Indie",
    "DRIPPIN': Best Rap Right Now",
    "EAR CANDY: Fresh Pop Picks",
    "FEMCEES: Best Female Rappers Now",
    "FIRESIDE: Warm Indie Sounds (SEASONAL)",
    "FIZZ: Tomorrow's Hits Today",
    "FRESCO: Fresh Latin Music",
    "GIANTS: New African Pop",
    "INFLUENCE: Viral Hits",
    "JAMZ: Best UK R&B",
    "K-POP and More",
    "LA MULTITUD: New Latin Pop",
    "LEVEL UP: EDM Next",
    "NEW + NOW: Essential New Music",
    "NEW YORK DRILL",
    "NOCHE BUENA: Latin Xmas (SEASONAL)",
    "ON THE UP: EDM Hits",
    "PORCH SWING: Emerging Folk, Country, Americana",
    "SHRED: Essential Metal",
    "SIZZLE: Hot UK Pop",
    "SOUNDCLOUD CHRISTMAS (SEASONAL)",
    "STITCHES: Indie New Arrivals",
    "TECHNO: New Techno Now",
    "THE DIVE: New Rock Now",
    "THE LOOK OUT: Tomorrow's Rap Hits",
    "TROPICAL POP",
    "TUNNEL: Best Electronic Now",
    "UNDERGROUND: New Underground Music",
    "VIBES: Best New R&B",
    "WARMS: Warm Soothing Soul (SEASONAL)",
  ],

  youtubePromotionSurface: [
    "Creator Music",
    "Programmed Playlist",
    "Shorts Audio Picker",
    "Living Room",
  ],
  youtubeReleaseStage: [
    "New Release",
    "Ongoing",
    "Pre-release (teasers, etc.)",
    "Previews",
    "Catalog",
    "Trending/Resurgent",
    "Anniversary",
    "Reissue",
    "Seasonal"
  ],
  // youtubeSongDetails: [
  //   "Previews",
  //   "New Release",
  //   "Ongoing Priority",
  //   "Catalog",
  //   "Trending/Resurgent",
  //   "Anniversary",
  //   "Reissue",
  //   "Seasonal",
  // ],
  youtubeTerritories: [
    "United States",
    "United Kingdom",
    "Germany/Austria/Switzerland",
    "France",
    "Brazil",
    "Japan",
    "Canada",
    "Mexico",
    "Spain",
    "Italy",
    "Australia/New Zealand",
    "India",
    "South Korea",
    "Middle East/North Africa",
    "Argentina",
    "Colombia",
    "Nigeria",
    "Ukraine",
  ],
  soundCloudReleaseStage: [
    "New Release",
    "Ongoing",
    "Pre-release (teasers, etc.)",
    "Previews",
    "Catalog",
    "Trending/Resurgent",
    "Anniversary",
    "Reissue",
    "Seasonal"
  ],
};

// We'll define a separate object for subgenres that depend on main genre
// Spotify subgenre mappings
export const dspSubgenres: DSPSubgenreMap = {
  spotify: {
    Acoustic: [
      "Acoustic Country",
      "Acoustic Folk",
      "Acoustic Pop",
      "Acoustic Rock",
      "Acoustic Singer-Songwriter",
      "Acoustic Soul",
      "Blues Singer-Songwriter",
      "Country Singer Songwriter",
      "Folk Singer-Songwriter",
      "Indie Singer-Songwriter",
      "Pop Singer-Songwriter",
      "Rock Singer-Songwriter",
      "Singer-Songwriter",
      "Soul Singer-Songwriter",
    ],
    "Children's": ["Children's Music", "Kindermusik", "Lullaby"],
    Classical: [
      "Baroque",
      "Carnatic Classical",
      "Chamber Music",
      "Chamber Pop",
      "Choral",
      "Classical",
      "Classical Piano",
      "Gregorian Chant",
      "Hindustani Classical",
      "J-Classical",
      "Medieval",
      "minimalism",
      "Neoclassical",
      "Opera",
      "Orchestra",
      "Requiem",
      "Renaissance",
      "Romantic",
      "String Orchestra",
      "Symphony",
    ],
    Country: [
      "Bluegrass",
      "Indie Bluegrass",
      "Jamgrass",
      "Acoustic Country",
      "Alt Country",
      "Americana",
      "Country",
      "Country Blues",
      "Country Hip Hop",
      "Country Québécois",
      "Country Rock",
      "Country Singer Songwriter",
      "Gothic Country",
      "Honky Tonk",
      "Newgrass",
      "Outlaw Country",
      "Pop Country",
      "Positive Country",
      "Red Dirt",
      "Southern Rock",
      "Texas Country",
      "Traditional Country",
      "Acoustic Folk",
      "Ambient Folk",
      "Basque Folk (Folk Vasco)",
      "Blues Roots",
      "Castilian Folk (Folk Castellano)",
      "Catalan Folk (Folk Catalán)",
      "Celtic",
      "Celtic Punk",
      "Celtic Rock",
      "Folk",
      "Folk Blues",
      "Folk Metal",
      "Folk Pop",
      "Folk Punk",
      "Folk Québécois",
      "Folk Rock",
      "Indie Folk",
      "Neofolk",
      "Retro Rock",
      "Rockabilly",
      "Roots Reggae",
      "Roots Rock",
      "Sea Shanties",
      "Traditional Folk",
    ],
    "Dance & Electronic": [
      "Ambient",
      "Ambient Drone",
      "Ambient Folk",
      "Ambient House",
      "Ambient Noise",
      "Dark Ambient",
      "Drone",
      "lowercase",
      "Post-Rock",
      "Space Music",
      "Bass",
      "Bass House",
      "Bassline",
      "Dubstep",
      "Future Bass",
      "Melodic Bass",
      "Riddim",
      "Trap",
      "Chillhop",
      "Experimental Beats",
      "Funk Beats",
      "Jazz Beats",
      "Lo-Fi Beats",
      "Lo-Fi Hip-Hop",
      "Trap Beats",
      "Acid House",
      "Acid Jazz",
      "Acid Rock",
      "Acid Techno",
      "Alternative Dance",
      "Amapiano",
      "Ballroom/Vogue",
      "Baltimore Club",
      "Big Beat",
      "Big Room",
      "Boogie",
      "Breakbeat",
      "Breakcore",
      "Budots",
      "Chicago House",
      "Chill House",
      "Chillstep",
      "Chillwave",
      "Christian EDM",
      "Club Music",
      "Cold Wave",
      "Dance",
      "Dance House",
      "Dance Pop",
      "Deep House",
      "Disco",
      "Disco House",
      "Downtempo",
      "Drift Phonk",
      "Drum and Bass",
      "Drumstep",
      "Dub Techno",
      "EDM",
      "EDM Trap",
      "EBM",
      "Electro",
      "Electro Corridos",
      "Electro House",
      "Electro R&B",
      "Electro Shaabi",
      "Electro Swing",
      "Electroclash",
      "Electronic",
      "Electronic Flamenco (Flamenco electrónico)",
      "Electronic Gospel",
      "Electronic Rock",
      "Electronica",
      "Electropop",
      "Epadunk",
      "Eurodance",
      "Experimental",
      "Footwork",
      "Frenchcore",
      "French House",
      "Funk Carioca",
      "Funky House",
      "Future Funk",
      "Future House",
      "G-House",
      "Gabber",
      "Glitch",
      "Gqom",
      "Guaracha",
      "Happy Hardcore",
      "Hard House",
      "Hard Techno",
      "Hardcore Techno",
      "Hardstyle",
      "Hardtekk",
      "Hi-NRG",
      "Hip House",
      "House",
      "Hyperpop",
      "IDM",
      "Indie Dance",
      "Indie Electronic",
      "Italo Dance",
      "Italo Disco",
      "Jersey Club",
      "Jungle",
      "Kwaito",
      "Latin House",
      "Liquid Funk",
      "Lo-Fi House",
      "Madchester",
      "Mahraganat",
      "Melbourne Bounce",
      "Melodic House",
      "Melodic Techno",
      "Miami Bass",
      "Minimal Techno",
      "Moombahton",
      "New Orleans Bounce",
      "New Rave",
      "New Wave",
      "Nightcore",
      "Nu Disco",
      "Organic House",
      "Philly Club",
      "Piano House",
      "Post-Disco",
      "Progressive House",
      "Progressive Trance",
      "Psytrance",
      "Rave",
      "Reggaeton",
      "Rominimal",
      "Russemusikk",
      "Shamstep",
      "Slap House",
      "Speedcore",
      "Stutter House",
      "Synthpop",
      "Synthwave",
      "Tech House",
      "Techno",
      "Trance",
      "Tribal House",
      "Trip Hop",
      "Tropical House",
      "UK Funky",
      "UK Garage",
      "Vaporwave",
      "Vinahouse",
      "Witch House",
    ],
    "Indie & Alternative": [
      "Alternative",
      "Alternative Dance",
      "Alternative Hip Hop",
      "Alternative Metal",
      "Alternative Pop",
      "Alternative R&B",
      "Alternative Rock",
      "Arab Indie",
      "Arab Trap",
      "Art Pop",
      "Bedroom Pop",
      "Bubblegum Pop",
      "Chill Pop",
      "Chinese Indie",
      "Conscious Hip-Hop",
      "Darkwave",
      "Dream Pop",
      "Electroclash",
      "Emo",
      "Emo Rap",
      "Experimental Hip Hop",
      "Garage Rock",
      "Hindi Indie",
      "Hyperpop",
      "Indie",
      "Indie Bluegrass",
      "Indie Dance",
      "Indie Electronic",
      "Indie Folk",
      "Indie Jazz",
      "Indie Mexicano",
      "Indie Pop",
      "Indie Punk",
      "Indie Québécois",
      "Indie R&B",
      "Indie Rock",
      "Indie Singer-Songwriter",
      "Indie Viet",
      "Indonesian Indie",
      "Indian Indie",
      "Industrial",
      "J-Alternative",
      "J-Indie",
      "Jangle Pop",
      "Krautrock",
      "Lo-Fi",
      "Lo-Fi Beats",
      "Lo-Fi Hip-Hop",
      "Lo-Fi Pop",
      "Lo-Fi Rock",
      "Maghreb Indie",
      "Midwest Emo",
      "Pinoy Alternative",
      "Pinoy Indie",
      "Post-Punk",
      "Psychedelic",
      "Shoegaze",
      "Slowcore",
      "Soft Rock",
      "Taiwanese Indie",
      "Thai Indie Pop",
      "Thai Indie Rock",
      "Traditional Folk",
    ],
    Jazz: [
      "Acid Jazz",
      "Afro-Cuban Jazz",
      "Arabic Jazz",
      "Bebop",
      "Big Band",
      "Boogie-Woogie",
      "Brazilian Jazz",
      "Contemporary Jazz",
      "Cool Jazz",
      "Ethiopian Jazz",
      "Experimental Jazz",
      "Flamenco Jazz",
      "Free Jazz",
      "French Jazz",
      "Hard Bop",
      "Indie Jazz",
      "Jazz",
      "Jazz Beats",
      "Jazz Blues",
      "Jazz Funk",
      "Jazz Fusion",
      "Jazz Rap",
      "Jazztronica",
      "Latin Jazz",
      "Lounge",
      "Post Bop",
      "Ragtime",
      "Smooth Jazz",
      "Soul Jazz",
      "Swing Music",
      "Vocal Jazz",
    ],
    "Latin Music": [
      "Argentine Rock",
      "Arrocha",
      "Axé",
      "Bachata",
      "Bachata Pop",
      "Banda",
      "Bolero (Latin)",
      "Bossa Nova",
      "Brazilian Funk",
      "Brazilian Gospel",
      "Brazilian Jazz",
      "Brazilian Pop",
      "Brazilian Rock",
      "Brega",
      "Brega Funk",
      "Carimbó",
      "Cha Cha Cha",
      "Champeta",
      "Chicha",
      "Colombian Pop",
      "Corrido",
      "Corridos Bélicos",
      "Corridos Tumbados",
      "Cumbia",
      "Cumbia Norteña",
      "Cumbia Sonidera",
      "Dembow",
      "Duranguense",
      "Electro Corridos",
      "Flamenco",
      "Flamenco Chill",
      "Flamenco Jazz",
      "Flamenco Pop",
      "Flamenco Urbano",
      "Folclor Andino",
      "Folclor Llanero",
      "Folclor Pacifico",
      "Folklore Argentino",
      "Forró",
      "Forró Tradicional",
      "Funk Consciente",
      "Grupera",
      "Guaracha",
      "Huayno",
      "Latin",
      "Latin Afrobeat",
      "Latin Afrobeats",
      "Latin Alternative",
      "Latin Dance",
      "Latin Folk",
      "Latin Hip Hop",
      "Latin House",
      "Latin Indie",
      "Latin Jazz",
      "Latin Pop",
      "Latin R&B",
      "Latin Rock",
      "Mambo",
      "Mambo Chileno",
      "Mariachi",
      "Merengue",
      "Mexican Hip Hop",
      "MPB",
      "Música Mexicana",
      "Música Nativista",
      "Música Popular Colombiana",
      "Música Tropical",
      "Neoperreo",
      "Norteño",
      "Norteño Sax",
      "Nueva Trova",
      "Pagode",
      "Pagode Baiano",
      "Pentecostal",
      "Pop Leve",
      "Pop Urbano",
      "Punto Guajiro",
      "Punta",
      "Ranchera",
      "Rap Nacional",
      "Reggae En Español",
      "Reggaeton",
      "Reggaeton Chileno",
      "Reggaeton Mexicano",
      "RKT",
      "Rock en Español",
      "Rock Mexicano",
      "Rock Urbano",
      "Sad Sierreño",
      "Salsa",
      "Salsa Choke",
      "Salsa Romantica",
      "Samba",
      "Seresta",
      "Sertanejo",
      "Sertanejo Tradicional",
      "Sertanejo Universitário",
      "Sierreño",
      "Ska Mexicano",
      "Son Cubano",
      "Tango",
      "Tecnobrega",
      "Timba",
      "Trap Argentino",
      "Trap Chileno",
      "Trap Latino",
      "Trova",
      "Turreo",
      "Urbano Latino",
      "Vallenato",
    ],
    "Non-Music": [
      "ASMR",
      "Ambient Noise",
      "Audio Plays",
      "Binaural Beats",
      "Comedy",
      "Fiction",
      "Nature Noise",
      "Nonfiction",
      "Poetry",
      "Spoken Word",
    ],
    Pop: [
      "Adult Contemporary",
      "Afrobeat",
      "Alternative Pop",
      "Arab Pop",
      "Arabesk",
      "Art Pop",
      "Austro Pop",
      "Bangla Pop",
      "Baroque Pop",
      "Bedroom Pop",
      "Bhojpuri Pop",
      "Brazilian Pop",
      "Bubblegum Pop",
      "Cantopop",
      "Chamber Pop",
      "Chanson",
      "Chanson Alternative",
      "Chanson Québécois",
      "Chill Pop",
      "Chinese R&B",
      "Christmas",
      "City Pop",
      "Colombian Pop",
      "C-Pop",
      "Dance Pop",
      "Dansband",
      "Dansktop",
      "Desi Pop",
      "Deutschpop",
      "Dream Pop",
      "Easy Listening",
      "Egyptian Pop",
      "Electropop",
      "Emo Pop",
      "Europop",
      "Folk Pop",
      "French Indie Pop",
      "Funk Pop",
      "Gujarati Pop",
      "Haryanvi Pop",
      "Hindi Pop",
      "Hyperpop",
      "Indie Pop",
      "Indonesian Pop",
      "Iskelmä",
      "J-Pop",
      "Jangle Pop",
      "K-Ballad",
      "K-Pop",
      "Kannada Pop",
      "Kayokyoku",
      "Kundiman",
      "Lagu Jawa",
      "Lagu Maluku",
      "Lagu Timur",
      "Latin Pop",
      "Lo-Fi Pop",
      "M-Pop",
      "Maghreb Pop",
      "Malay Pop",
      "Malayalam Pop",
      "Mandopop",
      "Marathi Pop",
      "Mizrahi",
      "Mizrahit",
      "Musicals",
      "Nederpop",
      "New Age",
      "New Wave",
      "Norsk Pop",
      "OPM",
      "P-Pop",
      "Pop",
      "Pop Country",
      "Pop Française",
      "Pop Leve",
      "Pop Punk",
      "Pop Québécois",
      "Pop R&B",
      "Pop Rap",
      "Pop Rock",
      "Pop Singer-Songwriter",
      "Pop Soul",
      "Pop Urbaine",
      "Pop Urbano",
      "Power Pop",
      "Psychedelic Pop",
      "Punjabi Pop",
      "R&B",
      "R&B Québécois",
      "Schlager",
      "Schlagerparty",
      "Shimmer Pop",
      "Soft Pop",
      "Soul",
      "Soundtrack",
      "Suomipop",
      "Synthpop",
      "T-Pop",
      "Taiwanese Pop",
      "Tamil Pop",
      "Telugu Pop",
      "Thai Pop",
      "Turkce Pop",
      "V-Pop",
      "Vocaloid",
      "Worship Pop",
    ],
    "R&B": [
      "Alternative R&B",
      "Bounce",
      "Chinese R&B",
      "Christian R&B",
      "Crunk",
      "Disco",
      "Doo-wop",
      "Electro R&B",
      "Go-Go",
      "Indie R&B",
      "J-R&B",
      "Latin R&B",
      "Motown",
      "Neo Soul",
      "New Jack Swing",
      "Philly Soul",
      "Pinoy R&B",
      "Pop R&B",
      "Pop Soul",
      "Quiet Storm",
      "R&B",
      "R&B Québécois",
      "Retro Soul",
      "Smooth R&B",
      "Soul",
      "Acoustic Soul",
      "Afro Soul",
      "Boogie",
      "Funk",
      "Funk Beats",
      "Funk Bruxaria",
      "Funk De BH",
      "Funk Melody",
      "Funk Pop",
      "Funk Rock",
      "Future Funk",
      "Go-Go",
      "Jazz Funk",
      "Northern Soul",
      "Smooth Soul",
      "Soul Blues",
      "Soul House",
      "Soul Jazz",
      "Soul Singer-Songwriter",
      "UK Funky",
      "Vaporwave",
    ],
    "Rap & Hip-Hop": [
      "Afro Adura",
      "Afro Soul",
      "Afrobeats",
      "Afrogospel",
      "Afropop",
      "Afroswing",
      "Algerian Hip-Hop",
      "Alternative Hip Hop",
      "Alternative R&B",
      "Amapiano",
      "Anime Rap",
      "Arabic Hip Hop",
      "Arab Trap",
      "Asakaa",
      "Aussie Drill",
      "Boom Bap",
      "Bounce",
      "Brooklyn Drill",
      "Chinese Hip Hop",
      "Chinese R&B",
      "Cloud Rap",
      "Conscious Hip-Hop",
      "Country Hip Hop",
      "Crunk",
      "Dark Trap",
      "Desi Hip Hop",
      "Deutschrap",
      "Drill",
      "East Coast Hip Hop",
      "Egyptian Hip Hop",
      "Emo Pop",
      "Emo Rap",
      "Experimental Hip Hop",
      "Freestyle",
      "Funk Beats",
      "Funk Carioca",
      "Funk Consciente",
      "Funk De BH",
      "G-Funk",
      "Gangster Rap",
      "Grime",
      "Hardcore Hip Hop",
      "Hip Hop",
      "Hip House",
      "Horrorcore",
      "Hyphy",
      "J-Rap",
      "Jazz Beats",
      "Jazz Rap",
      "K-Rap",
      "Khaleeji Hip-Hop",
      "Latin Afrobeat",
      "Latin Hip Hop",
      "Lo-Fi Beats",
      "Lo-Fi Hip-Hop",
      "Malay Hip Hop",
      "Malayalam Hip Hop",
      "Melodic Rap",
      "Meme Rap",
      "Memphis Rap",
      "Mexican Hip Hop",
      "Moroccan Hip-Hop",
      "Motswako",
      "Nerdcore",
      "New York Drill",
      "Norsk Rap",
      "Phonk",
      "Pinoy Hip Hop",
      "Pop Rap",
      "Punjabi Hip Hop",
      "Punk Rap",
      "Rage Rap",
      "Rap",
      "Rap Metal",
      "Rap Napoletano",
      "Rap Nacional",
      "Rap Québécois",
      "Rap Rock",
      "Rap Tuga",
      "Reggaeton",
      "Southern Hip Hop",
      "Suomirap",
      "Tamil Hip Hop",
      "Thai Hip Hop",
      "Thai Trap",
      "Trap",
      "Trap Argentino",
      "Trap Beats",
      "Trap Brasileiro",
      "Trap Chileno",
      "Trap Funk",
      "Trap Italiana",
      "Trap Latino",
      "Tunisian Hip-Hop",
      "Turkce Rap",
      "UK Drill",
      "Underground Hip Hop",
      "Vietnamese Hip Hop",
      "West Coast Hip Hop",
    ],
    "Religious Music": [
      "Afrogospel",
      "Bhajan",
      "Brazilian Gospel",
      "Christian Alternative",
      "Christian Country",
      "Christian EDM",
      "Christian Folk",
      "Christian Hip Hop",
      "Christian Music",
      "Christian Pop",
      "Christian R&B",
      "Christian Rock",
      "Contemporary Christian Music",
      "Devotional",
      "Electronic Gospel",
      "Faith",
      "Fújì",
      "Gnawa",
      "Gospel",
      "Gospel Blues",
      "Hymns",
      "Liturgical",
      "Pentecostal",
      "Positive Country",
      "Sholawat",
      "Southern Gospel",
      "Spiritual",
      "Sufi",
      "Traditional Gospel",
      "Worship",
      "Worship Pop",
    ],
    Rock: [
      "Acoustic Soul",
      "Blues",
      "Blues Roots",
      "Blues Rock",
      "Blues Singer-Songwriter",
      "Boogie-Woogie",
      "Chicago Blues",
      "Classic Blues",
      "Country Blues",
      "Delta Blues",
      "Folk Blues",
      "Gospel Blues",
      "Hill Country Blues",
      "Jazz Blues",
      "Jump Blues",
      "Louisiana Blues",
      "Modern Blues",
      "Soul Blues",
      "Texas Blues",
      "Alternative Metal",
      "Black Metal",
      "Deathcore",
      "Death Metal",
      "Djent",
      "Doom Metal",
      "Folk Metal",
      "Glam Metal",
      "Gothic Metal",
      "Groove Metal",
      "Grindcore",
      "Heavy Metal",
      "Industrial Metal",
      "Medieval Metal",
      "Melodic Death Metal",
      "Melodic Metal",
      "Metal",
      "Metalcore",
      "Nu Metal",
      "Pirate Metal",
      "Power Metal",
      "Progressive Metal",
      "Rap Metal",
      "Sludge Metal",
      "Speed Metal",
      "Stoner Metal",
      "Symphonic Metal",
      "Thrash Metal",
      "Celtic Punk",
      "Deathrock",
      "Emo",
      "Emocore",
      "Folk Punk",
      "Hardcore",
      "Hardcore Punk",
      "Horror Punk",
      "Indie Punk",
      "Melodic Hardcore",
      "Midwest Emo",
      "Pop Punk",
      "Post-Hardcore",
      "Post-Punk",
      "Proto-punk",
      "Psychobilly",
      "Punk",
      "Punk Rap",
      "Screamo",
      "Ska",
      "Ska Punk",
      "Skate Punk",
      "Acid Rock",
      "Album Rock",
      "Alternative",
      "Alternative Metal",
      "Alternative Rock",
      "Anatolian Rock",
      "Arena Rock",
      "Argentine Rock",
      "Art Rock",
      "Bisrock",
      "Blues Rock",
      "Brazilian Rock",
      "Celtic Rock",
      "Chinese Rock",
      "Classic Rock",
      "Country Rock",
      "Dark Cabaret",
      "Electronic Rock",
      "Emo",
      "Emo Rap",
      "Experimental Rock",
      "Folk Rock",
      "Funk Rock",
      "Garage Rock",
      "Glam Metal",
      "Glam Rock",
      "Gothic Country",
      "Grunge",
      "Hard Rock",
      "Indie Mexicano",
      "Indie Rock",
      "Indorock",
      "Industrial",
      "Industrial Rock",
      "J-Rock",
      "Jam Band",
      "K-Rock",
      "Krautrock",
      "Lo-Fi Rock",
      "Madchester",
      "Math Rock",
      "Modern Rock",
      "Noise Rock",
      "Pinoy Rock",
      "Pop Punk",
      "Pop Rock",
      "Post-Grunge",
      "Post-Punk",
      "Post-Rock",
      "Power Pop",
      "Progressive Rock",
      "Psychedelic",
      "Punk",
      "Rap Rock",
      "Retro Rock",
      "Rock",
      "Rock and Roll",
      "Rock en Español",
      "Rock Mexicano",
      "Rock Québécois",
      "Rock Singer-Songwriter",
      "Rock Urbano",
      "Rockabilly",
      "Roots Rock",
      "Shoegaze",
      "Slowcore",
      "Soft Rock",
      "Southern Rock",
      "Space Rock",
      "Stoner Rock",
      "Suomirock",
      "Surf Rock",
      "Symphonic Rock",
      "Thai Rock",
    ],
    World: [
      "Afro Adura",
      "Afro House",
      "Afro Soul",
      "Afrobeat",
      "Afrobeats",
      "Afrogospel",
      "Afropop",
      "Afroswing",
      "Alté",
      "Amapiano",
      "Asakaa",
      "Azonto",
      "Bikutsi",
      "Bongo Flava",
      "Coupé Décalé",
      "Ethiopian Jazz",
      "Gengetone",
      "Highlife",
      "Hiplife",
      "Kuduro",
      "Maloya",
      "Maskandi",
      "Motswako",
      "N'dombolo",
      "Rhumba",
      "Rumba (Congolese)",
      "Shaaby",
      "Singeli",
      "Soukouss",
      "Candombe",
      "Chamamé",
      "Cuarteto",
      "Murga",
      "Agronejo",
      "Axé",
      "Bossa Nova",
      "Brazilian Bass",
      "Brazilian Funk",
      "Brazilian Gospel",
      "Brazilian Jazz",
      "Brazilian Pop",
      "Brazilian Rock",
      "Brega",
      "Brega Funk",
      "Carimbó",
      "Forró",
      "Forró Tradicional",
      "Funk Bruxaria",
      "Funk Consciente",
      "Funk De BH",
      "Funk Melody",
      "MPB",
      "Música Nativista",
      "Nova MPB",
      "Outros (Brasil)",
      "Pagode",
      "Pagode Baiano",
      "Piseiro",
      "Pop Leve",
      "Samba",
      "Sertanejo",
      "Sertanejo Tradicional",
      "Sertanejo Universitário",
      "Tecnobrega",
      "Trap Brasileiro",
      "Trap Funk",
      "Blues Singer-Songwriter",
      "Chanson Québécois",
      "Country Québécois",
      "Folk Québécois",
      "Folklore Québécois",
      "Indie Québécois",
      "Pop Québécois",
      "R&B Québécois",
      "Rap Québécois",
      "Rock Québécois",
      "Bachata",
      "Calypso",
      "Dancehall",
      "Dembow",
      "Dub",
      "Lovers Rock",
      "NZ Reggae",
      "Ragga",
      "Reggae",
      "Reggae En Español",
      "Reggae Rock",
      "Reggaeton",
      "Rocksteady",
      "Roots Reggae",
      "Soca",
      "Chanson",
      "Chanson Alternative",
      "Chanson Québécois",
      "Coupé Décalé",
      "French House",
      "French Indie Pop",
      "French Jazz",
      "Pop Française",
      "Pop Urbaine",
      "Variété Française",
      "Variété Urbaine",
      "Austro Pop",
      "Dansband",
      "Deutschpop",
      "Deutschrap",
      "Disco Polo",
      "Neue Deutsche Welle",
      "Schlager",
      "Schlagerparty",
      "Schweizer Mundart",
      "Volksmusik",
      "Entekhno",
      "Laiko",
      "Mulatós",
      "Bangla Pop",
      "Bhajan",
      "Bhangra",
      "Bhojiwood",
      "Bhojpuri Pop",
      "Bollywood",
      "Carnatic Classical",
      "Chutney",
      "Desi",
      "Desi Hip Hop",
      "Desi Pop",
      "Filmi",
      "Ghazal",
      "Gujarati Garba",
      "Gujarati Pop",
      "Haryanvi Pop",
      "Hindi Hip Hop",
      "Hindi Indie",
      "Hindi Pop",
      "Hindustani Classical",
      "Indian Fusion",
      "Kannada Pop",
      "Kollywood",
      "Malayalam Hip Hop",
      "Malayalam Pop",
      "Marathi Pop",
      "Mollywood",
      "Punjabi Hip Hop",
      "Punjabi Pop",
      "Qawwali",
      "Sandalwood",
      "Tamil Dance",
      "Tamil Hip Hop",
      "Tamil Indie",
      "Tamil Pop",
      "Telugu Pop",
      "Tollywood",
      "Mizrahi",
      "Mizrahit",
      "Cantautorato Italiano",
      "Canzone Napoletana",
      "Neomelodico",
      "Neomelodico Napoletano",
      "Rap Napoletano",
      "Trap Italiana",
      "Anime",
      "J-Alternative",
      "J-Classical",
      "J-Dance",
      "J-Pop",
      "J-R&B",
      "J-Rap",
      "J-Rock",
      "J-Tracks",
      "City Pop",
      "Enka",
      "Japanese VGM",
      "Kayokyoku",
      "Shibuya-kei",
      "Visual Kei",
      "Vocaloid",
      "Mor Lum",
      "M'balax",
      "Algerian Chaabi",
      "Arab Pop",
      "Arab Indie",
      "Arab Trap",
      "Arabic Hip Hop",
      "Arabic Jazz",
      "Dabke",
      "Egyptian Hip Hop",
      "Egyptian Pop",
      "Egyptian Shaabi",
      "Electro Shaabi",
      "Khaleeji",
      "Khaleeji Hip-Hop",
      "Khaleeji Saudi",
      "Mahraganat",
      "Mizrahi",
      "Mizrahit",
      "Moroccan Chaabi",
      "Moroccan Hip-Hop",
      "Rai",
      "Shamstep",
      "Sharqi",
      "Sheilat",
      "Tunisian Hip-Hop",
      "Disco Polo",
      "Fado",
      "Basque Folk (Folk Vasco)",
      "Cajun",
      "Castilian Folk (Folk Castellano)",
      "Catalan Folk (Folk Catalán)",
      "Celtic",
      "Folklore Argentino",
      "Folklore Québécois",
      "Folclor Andino",
      "Folclor Llanero",
      "Folclor Pacifico",
      "Harana",
      "Irish Traditional",
      "Maskandi",
      "Native American Roots",
      "Pow Wow",
      "Traditional Music",
      "Visor",
      "Zydeco",
      "Dancehall",
      "Dembow",
      "Dub",
      "Lovers Rock",
      "NZ Reggae",
      "Ragga",
      "Reggae",
      "Reggae En Español",
      "Reggae Rock",
      "Reggaeton",
      "Rocksteady",
      "Roots Reggae",
      "Manele",
      "Rominimal",
      "Trapanele",
      "Russian Chanson",
      "M'balax",
      "Amapiano",
      "Gqom",
      "Kwaito",
      "Maskandi",
      "Luk Thung",
      "Mor Lum",
      "Phleng Phuea Chiwit",
      "Southern Thai Music",
      "T-Pop",
      "Thai Country",
      "Thai Hip Hop",
      "Thai Indie Pop",
      "Thai Indie Rock",
      "Thai Rock",
      "Thai Trap",
      "Celtic",
      "Flamenco",
      "Folk",
      "Gufeng",
      "Harana",
      "Kagok",
      "Malay Songs",
      "Polka",
      "Traditional Music",
      "Visor",
      "Anatolian Rock",
      "Arabesk",
      "Karadeniz Turkuleri",
      "Oyun Havasi",
      "Turkce Pop",
      "Turkce Rap",
      "Turkish trap pop",
      "Candombe",
      "Murga",
      "Indie Viet",
      "Lofi Viet",
      "V-Pop",
      "Vietnamese Bolero",
      "Vietnamese Hip Hop",
    ],
  },
  amazon: {
    Acoustic: ["Acoustic Pop", "Singer-Songwriter"],
    "Children's": [
      "Children's Cartoons",
      "Children's Folk",
      "Classic Disney",
      "Classic Lullabies",
      "Disney",
      "Disney Lullabies",
      "Kindie",
      "Lullabies",
      "Nursery Rhymes",
    ],
    Classical: [
      "Classical: Baroque Period",
      "Classocal Crossover",
      "Classical: Choral Music",
      "Classical: Classical Period",
      "Classical: Medieval Period",
      "Classical: Renaissance Period",
      "Classical: Romantic Period",
      "Contemporary Clasical",
    ],
    Country: [
      "Alt-Country & Americana",
      "Alternative Country Rock",
      "Bluegrass",
      "Classic Country",
      "Classic Folk",
      "Contemporary Country",
      "Contemporary Folk",
      "Country Pop",
      "Country Rock",
      "Cowboy & Western Country",
      "Folk",
      "Modern Folk",
      "Outlaw Country",
      "Red Dirt Country",
      "Texas Roadhouse",
      "Traditional Country",
      "Traditional Folk",
    ],
    "Dance & Electronic": [
      "UK Synth Pop",
      "Ambient",
      "Bassline",
      "Breakbeat",
      "Chill Electronic",
      "Dance Pop",
      "Deep House",
      "Downtempo",
      "Drum & Bass",
      "Dubstep",
      "EDM",
      "Electronica",
      "Future Bass",
      "Future House",
      "House",
      "Nu Disco",
      "Progressive House",
      "Tech House",
      "Techno",
      "Trance",
      "Trip Hop",
      "Tropical House",
      "UK Garage",
    ],
    Holiday: ["Holiday"],
    "Indian Music": [
      "Bhangra",
      "Bollywood",
      "Carnatic Classical",
      "Ghazal",
      "Hindustani Classical",
      "Indian Classical",
      "Indian Folk",
      "Indian Instrumental",
      "Indian Pop",
      "Qawwali",
    ],
    "Indie & Alternative": [
      "Alternative",
      "Britpop",
      "Electronic Rock",
      "Folk Rock",
      "Indie & Lo-Fi",
      "Indie Dance",
      "Indie Folk",
      "Indie Rock",
      "Indie Pop",
      "Lo-Fi Rock",
      "Modern Alternative",
    ],
    Jazz: [
      "Acid Jazz",
      "Avant Garde Jazz",
      "Bebop",
      "Big Band",
      "Contemporary Jazz",
      "Cool Jazz",
      "Free Jazz",
      "Hard Bop",
      "Jazz",
      "Jazz Fusion",
      "Jazz Rock",
      "Latin Jazz",
      "Lounge",
      "New Orleans Jazz",
      "Post-Bop",
      "Smooth Jazz",
      "Soul Jazz",
      "Swing Jazz",
    ],
    "Latin Music": [
      "Bachata",
      "Banda",
      "Bossa Nova",
      "Brazilian",
      "Brazilian Catholic",
      "Brazilian Children's",
      "Brazilian Christian",
      "Brazilian Funk",
      "Brazilian Metal",
      "Brazilian Pop",
      "Brazilian Rap",
      "Brazilian Rock",
      "Brazilian Trap",
      "Champeta",
      "Colombian Popular",
      "Corrido",
      "Cuban Music",
      "Cumbia",
      "Dembow",
      "Forró",
      "Grupera",
      "Hip-Hop Mexicano",
      "Latin Alternative",
      "Latin Christian",
      "Latin Pop",
      "Latin Rap",
      "Latin Rock",
      "Latin Trap",
      "Latin Urban",
      "Latino",
      "Mariachi",
      "Merengue",
      "Mexican",
      "MPB",
      "Norteno",
      "Nova MPB",
      "Pagode",
      "Pisadinha",
      "Rancera",
      "Reggaeton",
      "Regional Mexican",
      "Rock En Espanol",
      "Salsa",
      "Samba",
      "Sertanejo",
      "Sertanejo Raiz",
      "Spanish Hip-Hop",
      "Pop in Spanish",
      "Tejano",
      "Tropical",
      "Vallenato",
    ],
    "New Age": ["New Age"],
    "Non-Music": ["Stand-Up Comedy", "Spoken Word", "Comedy Music"],
    Pop: [
      "Adult Contemporary",
      "Alternative Pop",
      "European Alternative Pop",
      "Cantautorato",
      "Crooner & Easy Listening",
      "Easy Listening",
      "Exotica",
      "Hi-NRG",
      "Hyperpop",
      "Pop",
      "Sophisti-pop",
      "Space Age Pop",
    ],
    "R&B": [
      "Adult Contemporary R&B",
      "Alternative R&B",
      "Classic R&B",
      "Classic Soul",
      "Contemporary R&B",
      "Deep Soul",
      "Detroit Soul",
      "Disco",
      "Funk",
      "Go-Go",
      "Modern R&B",
      "Modern Soul",
      "Neo Soul",
      "Old-School R&B",
      "Soul",
      "Swamp Funk",
    ],
    "Rap & Hip-Hop": [
      "Alternative Hip-Hop",
      "Bounce",
      "Conscious Rap",
      "Contemporary Rap",
      "Crunk",
      "German Rap & Hip-Hop",
      "Drill",
      "East Coast Hip-Hop",
      "Emo Rap",
      "Experimental Hip-Hop",
      "Lo-Fi Hip-Hop",
      "Miami Bass",
      "Modern Hip-Hop",
      "Modern Rap",
      "[D]Classic Hip-Hop",
      "Old Skool Rap",
      "Pop Rap",
      "Rap From France",
      "Rap Italiano",
      "Snap",
      "Southern Rap",
      "Trap Rap",
      "Uk Hip-Hop",
      "West Coast Hip-Hop",
    ],
    "Religious Music": [
      "Christian Alternative",
      "Christian Black Metal",
      "Christian Contemporary",
      "Christian Instrumental",
      "Christian Pop",
      "Christian Rap",
      "Christian Rock",
      "Country Christian",
      "Gospel",
      "Hymns",
      "Modern Gospel",
      "Spiritual",
      "Southern Gospel",
      "Traditional Gospel",
    ],
    Rock: [
      "Adult Album Alternative",
      "Adult Oriented Rock",
      "Alternative Metal",
      "Alternative Rock",
      "Black Metal",
      "Blues Rock",
      "British Blues",
      "British Invasion",
      "Classic Rock",
      "Celtic Punk",
      "Death Metal",
      "German Rock",
      "Dream Pop",
      "Emo Rock",
      "Extreme Metal",
      "Garage Rock",
      "Glam",
      "Glam Metal",
      "Grunge",
      "Hard Rock",
      "Hard Rock & Metal",
      "Hardcore Punk",
      "Rock Italiano",
      "Metal",
      "Metalcore",
      "Pop Punk",
      "Post Punk",
      "Progessive Rock",
      "Psychedlic Rock",
      "Punk",
      "Rock'n'Roll",
      "Rock From France",
      "Rockabilly",
      "Shoegaze",
      "Surf",
      "Texas Blues Rock",
      "Thrash & Speed Metal",
      "Thrash Metal",
      "Yacht Rock",
    ],
    World: [
      "Deutscher Pop",
      "French Pop",
      "Italian Indie Pop",
      "K-pop",
      "Italian Pop",
      "Anime",
      "Japanese City Pop",
      "Enka",
      "Japanese Dance Pop",
      "Japanese Hip-Hop",
      "J-Pop",
      "Japanese R&B",
      "Japanese Rock",
      "Showa-Era Japanese Pop",
      "Video Game",
      "Afropop",
      "Afrobeat",
      "African",
      "African Traditional Music",
      "Arabic",
      "Dancehall",
      "Dub",
      "Neapolitan",
      "Reggae",
      "Sertanejo",
      "Ska",
      "Soca",
      "French Variety",
      "Worldbeat",
      "German Folk Music",
      "Volkstuemlich",
      "New German Folk Music",
      "Blasmusik",
      "Ballermann",
      "Oktoberfest",
      "Karneval",
      "Kölner Karneval",
    ],
  },
  deezer: {
    "Children's": ["Kids"],
    Classical: ["Classical"],
    Country: ["Alt Country", "Americana", "Bluegrass", "Country", "Folk"],
    "Dance & Electronic": [
      "Ambient",
      "Dance & EDM",
      "Electronic",
      "House",
      "Lofi",
      "Techno",
    ],
    "Indie & Alternative": ["Alternative"],
    Jazz: ["Jazz"],
    "Latin Music": ["Forró", "Latin", "Reggaeton", "Samba/Pagode", "Zouk"],
    Pop: ["Hyperpop", "Pop", "Soundtracks"],
    "R&B": ["Soul", "R&B"],
    "Rap & Hip-Hop": ["Old School", "Rap"],
    "Religious Music": ["Christian", "Gospel"],
    Rock: ["Metal", "Rock"],
    World: [
      "Afrobeats",
      "Anime",
      "BR funk",
      "French Chanson",
      "French Music",
      "J-Pop",
      "K-Pop",
      "MPB",
      "Reggae",
      "Schlager",
      "Sertanejo",
    ],
  },
  audiomack: {
    Country: ["Country"],
    "Dance & Electronic": ["Electronic", "Lo-Fi"],
    "Latin Music": ["Latin", "Mexican"],
    Pop: ["Pop"],
    "R&B": ["R&B"],
    "Rap & Hip-Hop": ["Hip-Hop/Rap"],
    "Religious Music": ["Gospel"],
    Rock: ["Rock"],
    World: ["Afrosounds", "Caribbean"],
  },
  TIDAL: {
    Acoustic: ["Singer-Songwriter"],
    "Children's": ["Kids"],
    Classical: ["Classical"],
    Country: ["Country", "Folk/Americana"],
    "Dance & Electronic": ["Dance", "Electronic", "DJ"],
    "Indie & Alternative": ["Alternative", "Indie"],
    Jazz: ["Blues", "Jazz"],
    "Latin Music": ["Latin"],
    "Non-Music": ["Comedy", "Audiobooks"],
    Pop: [
      "K-Pop",
      "Legacy",
      "Pop",
      "Soul",
      "Soundtracks",
      "Musicals",
      "Mixed",
      "Culture",
      "Gaming",
      "Singer-Songwriter",
    ],
    "R&B": ["R&B", "Funk"],
    "Rap & Hip-Hop": ["Deutschrap", "Hip-Hop"],
    "Religious Music": ["Gospel/Christian"],
    Rock: ["Metal", "Punk", "Rock", "Ska", "Blues"],
    World: ["African/Afrobeat", "Reggae/Dancehall", "World", "Schlager"],
  },
  soundcloud: {
    "Indie & Alternative": ["Alternative", "Indie", "Alt Rock"],
    Country: ["Country", "Country Rap"],
    "Dance & Electronic": ["Dance/Electronic"],
    World: [
      "Afrobeats",
      "Afropop",
      "Dancehall",
      "J-Pop",
      "K-Pop",
      "Latin",
      "Reggae",
      "World",
    ],
    "Rap & Hip-Hop": ["Hip-Hop/Rap"],
    Pop: ["Pop"],
    "R&B": ["R&B/Soul"],
    Rock: ["Rock", "Metal"],
    Holiday: ["Holiday"],
  },
  youtube: {},
};
